import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  zReports: [],
  currentReport: null,
  latestShift: null,
  success: false,
  error: null,
  message: null,
};

export const zReportReducer = createReducer(initialState, (builder) => {
  builder
    // Generate Z Report
    .addCase("generateZReportRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("generateZReportSuccess", (state, action) => {
      state.isLoading = false;
      state.currentReport = action.payload;
      state.success = true;
      state.error = null;
    })
    .addCase("generateZReportFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Get Z Reports by Store
    .addCase("getZReportsByStoreRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("getZReportsByStoreSuccess", (state, action) => {
      state.isLoading = false;
      state.zReports = action.payload;
      state.error = null;
    })
    .addCase("getZReportsByStoreFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Z Report by ID
    .addCase("getZReportByIdRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("getZReportByIdSuccess", (state, action) => {
      state.isLoading = false;
      state.currentReport = action.payload;
      state.error = null;
    })
    .addCase("getZReportByIdFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Latest Shift
    .addCase("getLatestShiftRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("getLatestShiftSuccess", (state, action) => {
      state.isLoading = false;
      state.latestShift = action.payload;
      state.error = null;
    })
    .addCase("getLatestShiftFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Z Reports by Date Range
    .addCase("getZReportsByDateRangeRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("getZReportsByDateRangeSuccess", (state, action) => {
      state.isLoading = false;
      state.zReports = action.payload;
      state.error = null;
    })
    .addCase("getZReportsByDateRangeFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Delete Z Report
    .addCase("deleteZReportRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("deleteZReportSuccess", (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
      state.error = null;
    })
    .addCase("deleteZReportFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Print Z Report
    .addCase("printZReportRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("printZReportSuccess", (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
      state.error = null;
    })
    .addCase("printZReportFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Clear Errors
    .addCase("clearErrors", (state) => {
      state.error = null;
    })

    // Clear Success Messages
    .addCase("clearSuccess", (state) => {
      state.message = null;
      state.success = false;
    });
});
